export const IMG = {
  hero: "https://images.unsplash.com/photo-1598718544285-7180f670198b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxoYXJkd29vZCUyMGZsb29yJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxNTU4MTk2fDA&ixlib=rb-4.1.0&q=85",
  heroAlt:
    "https://images.unsplash.com/photo-1585128792020-803d29415281?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHxfHxoYXJkd29vZCUyMGZsb29yJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxNTU4MTk2fDA&ixlib=rb-4.1.0&q=85",
  craftsman:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_coc-floors/artifacts/b7606b2053537452_WhatsApp%20Image%202026-10-09%20at%2015.47.12%20%282%29.webp",
};

export const SERVICES = [
  {
    id: "hardwood",
    title: "Solid & Engineered Hardwood",
    desc: "Heritage oak, walnut and ash — laid, finished and sealed to museum standard. Parquet, herringbone and wide-plank formats.",
    img: "https://images.unsplash.com/photo-1598718544285-7180f670198b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxoYXJkd29vZCUyMGZsb29yJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxNTU4MTk2fDA&ixlib=rb-4.1.0&q=85",
    tags: ["Herringbone", "Parquet", "Wide plank"],
    range: [60, 110],
  },
  {
    id: "laminate",
    title: "Laminate Flooring",
    desc: "Hard-wearing, beautifully textured laminate for busy homes — fast installation without compromising the finish.",
    img: "https://images.unsplash.com/photo-1584622781564-1d987f7333c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxoYXJkd29vZCUyMGZsb29yJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxNTU4MTk2fDA&ixlib=rb-4.1.0&q=85",
    tags: ["AC4–AC5 rated", "Quick fit", "Family proof"],
    range: [25, 40],
  },
  {
    id: "lvt",
    title: "LVT & Luxury Vinyl",
    desc: "Waterproof, warm underfoot and indistinguishable from natural timber or stone. Perfect for kitchens and bathrooms.",
    img: "https://images.unsplash.com/photo-1731185752376-a4cf3e8556fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHxfHxsdXh1cnklMjB2aW55bCUyMGZsb29yJTIwdGlsZXIlMjB3b3JraW5nfGVufDB8fHx8MTc5MTU1ODE5Nnww&ixlib=rb-4.1.0&q=85",
    tags: ["Waterproof", "Stone & wood effects", "UFH compatible"],
    range: [35, 60],
  },
  {
    id: "tiling",
    title: "Luxury Tiling",
    desc: "Porcelain, ceramic and mosaic floors set with laser precision — from minimalist large-format slabs to intricate mosaics.",
    img: "https://images.unsplash.com/photo-1560005627-c96e0aeb6eaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aW55bCUyMGZsb29yJTIwdGlsZXIlMjB3b3JraW5nfGVufDB8fHx8MTc5MTU1ODE5Nnww&ixlib=rb-4.1.0&q=85",
    tags: ["Porcelain", "Mosaic", "Large format"],
    range: [50, 90],
  },
  {
    id: "carpet",
    title: "Premium Carpet",
    desc: "Deep-pile wool, loop textures and commercial carpet tiles — measured, cut and stretched for a flawless fit.",
    img: "https://images.unsplash.com/photo-1766802124812-c4f0c867b57c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjYXJwZXQlMjB0aWxlcyUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MTU1ODIwNHww&ixlib=rb-4.1.0&q=85",
    tags: ["Wool", "Carpet tiles", "Commercial"],
    range: [20, 45],
  },
  {
    id: "repairs",
    title: "Floor Repairs & Restoration",
    desc: "Dustless sanding, board replacement, re-sealing and subfloor correction — we bring tired floors back to life.",
    img: "https://images.unsplash.com/photo-1646119955125-7ef8819c813a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwZmxvb3IlMjBpbnN0YWxsYXRpb24lMjB0b29sJTIwd29ya2VyfGVufDB8fHx8MTc5MTU1ODIwNHww&ixlib=rb-4.1.0&q=85",
    tags: ["Dustless sanding", "Re-sealing", "Subfloor prep"],
    range: [15, 30],
  },
];

const ASSET =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_coc-floors/artifacts";

export const PROJECTS = [
  {
    id: "coc-resin-corridor",
    title: "Commercial Resin Corridor",
    category: "Resin",
    url: `${ASSET}/0637f9c84b2382e6_WhatsApp%20Image%202026-10-02%20at%2018.39.33%20%281%29.webp`,
    location: "Commercial project",
    year: "2026",
    span: "md:col-span-5 md:row-span-2",
  },
  {
    id: "coc-herringbone-living",
    title: "Herringbone Living Space",
    category: "Hardwood",
    url: `${ASSET}/4a1a5c42df832c4e_WhatsApp%20Image%202026-10-09%20at%2015.47.12.webp`,
    location: "Residential",
    year: "2026",
    span: "md:col-span-7",
  },
  {
    id: "coc-kitchen-lvt",
    title: "Kitchen Herringbone LVT",
    category: "LVT / Vinyl",
    url: `${ASSET}/7e8d5aa47f4d48ff_WhatsApp%20Image%202026-10-02%20at%2017.35.44%20%281%29.webp`,
    location: "Residential kitchen",
    year: "2026",
    span: "md:col-span-7",
  },
  {
    id: "coc-basement-herringbone",
    title: "Basement Herringbone Conversion",
    category: "Hardwood",
    url: `${ASSET}/422859494abafedb_WhatsApp%20Image%202026-10-09%20at%2015.47.12%20%284%29.webp`,
    location: "Basement conversion",
    year: "2026",
    span: "md:col-span-5",
  },
  {
    id: "coc-staircase-vinyl",
    title: "Staircase Carpet & Vinyl Risers",
    category: "Carpet",
    url: `${ASSET}/e18ebc1ea1667bbd_WhatsApp%20Image%202026-10-09%20at%2016.12.40.jpeg`,
    location: "Residential staircase",
    year: "2026",
    span: "md:col-span-7",
  },
  {
    id: "coc-loft-oak",
    title: "Loft Engineered Oak",
    category: "Hardwood",
    url: `${ASSET}/1987397be56f8a42_WhatsApp%20Image%202026-10-02%20at%2018.43.49%20%282%29.jpeg`,
    location: "Loft conversion",
    year: "2026",
    span: "md:col-span-12",
  },
  {
    id: "project-3",
    title: "Artisanal Botanical Mosaic Tiling",
    category: "Tiling",
    url: "https://images.unsplash.com/photo-1560005627-c96e0aeb6eaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aW55bCUyMGZsb29yJTIwdGlsZXIlMjB3b3JraW5nfGVufDB8fHx8MTc5MTU1ODE5Nnww&ixlib=rb-4.1.0&q=85",
    location: "Chelsea Residence",
    year: "2024",
    span: "md:col-span-5",
  },
  {
    id: "project-4",
    title: "Contemporary Gallery Hall",
    category: "Carpet",
    url: "https://images.unsplash.com/photo-1766802124812-c4f0c867b57c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjYXJwZXQlMjB0aWxlcyUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MTU1ODIwNHww&ixlib=rb-4.1.0&q=85",
    location: "Soho Studio",
    year: "2025",
    span: "md:col-span-6",
  },
  {
    id: "project-5",
    title: "Precision Floor Subbase Restoration",
    category: "Repairs",
    url: "https://images.unsplash.com/photo-1646119955125-7ef8819c813a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwZmxvb3IlMjBpbnN0YWxsYXRpb24lMjB0b29sJTIwd29ya2VyfGVufDB8fHx8MTc5MTU1ODIwNHww&ixlib=rb-4.1.0&q=85",
    location: "Richmond Townhouse",
    year: "2024",
    span: "md:col-span-6",
  },
  {
    id: "project-6",
    title: "Scandinavian Light Ash Laminate",
    category: "Laminate",
    url: "https://images.unsplash.com/photo-1584622781564-1d987f7333c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxoYXJkd29vZCUyMGZsb29yJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkxNTU4MTk2fDA&ixlib=rb-4.1.0&q=85",
    location: "Hampstead Modern",
    year: "2025",
    span: "md:col-span-12",
  },
];

export const FILTERS = [
  { id: "all", label: "All", testid: "gallery-filter-all" },
  { id: "Hardwood", label: "Hardwood", testid: "gallery-filter-hardwood" },
  { id: "LVT / Vinyl", label: "LVT / Vinyl", testid: "gallery-filter-lvt" },
  { id: "Resin", label: "Resin", testid: "gallery-filter-resin" },
  { id: "Tiling", label: "Tiling", testid: "gallery-filter-tiling" },
  { id: "Carpet", label: "Carpet", testid: "gallery-filter-carpet" },
  { id: "Repairs", label: "Repairs", testid: "gallery-filter-repairs" },
];

export const TESTIMONIALS = [
  {
    quote:
      "The herringbone they laid in our hallway is the single most commented-on feature of the house. Immaculate, quiet, exact.",
    name: "Eleanor Whitfield",
    role: "Homeowner, Richmond",
    rating: 5,
  },
  {
    quote:
      "We specify COC on every residential project now. Their subfloor preparation alone puts them in a different class.",
    name: "Marcus Oyelaran",
    role: "Principal Architect, MO Studio",
    rating: 5,
  },
  {
    quote:
      "Three commercial units, zero snags, delivered ahead of programme. Rare reliability in this trade.",
    name: "Priya Nair",
    role: "Property Manager, Kestrel Estates",
    rating: 5,
  },
];

export const CONTACT = {
  phone: "+44 7521 066187",
  email: "cocflooringltd@gmail.com",
  area: "London & Surrounding Areas",
  hours: "Mon – Sat, 8:00 – 18:00",
};
